type Props = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};
export const Checkbox = ({ label, checked, onChange }: Props) => {
  return (
    <label className="flex items-center cursor-pointer text-base">
      <input
        type="checkbox"
        className="absolute opacity-0 peer"
        checked={checked}
        onChange={() => onChange(!checked)}
      />
      <div className='w-6 h-6 mr-[10px] border border-[#E5E5E5] overflow-hidden rounded-sm relative peer-checked:after:block after:hidden after:content-[""] after:absolute after:inset-0 after:bg-primary' />
      <span>{label}</span>
    </label>
  );
};
